import { eigenLeadsPalette } from './eigenLeadsPalette';

export const ElDefs = ({ prefix, isDark }) => {
  const c = eigenLeadsPalette(isDark);
  return (
    <defs>
      <linearGradient id={`${prefix}-bus`} x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor={c.indigo} stopOpacity="0" />
        <stop offset="40%" stopColor={c.indigo} stopOpacity="0.9" />
        <stop offset="100%" stopColor={c.emerald} stopOpacity="0" />
      </linearGradient>
      <linearGradient id={`${prefix}-panel`} x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor={isDark ? '#141824' : '#ffffff'} />
        <stop offset="100%" stopColor={isDark ? '#0c0e16' : '#f1f5f9'} />
      </linearGradient>
      <filter id={`${prefix}-glow`} x="-40%" y="-40%" width="180%" height="180%">
        <feGaussianBlur stdDeviation="3" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id={`${prefix}-shadow`} x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="0" dy="2" stdDeviation="3" floodColor="#000" floodOpacity={isDark ? 0.45 : 0.12} />
      </filter>
      <marker id={`${prefix}-arrow`} markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
        <path d="M0,0 L7,3.5 L0,7 Z" fill={c.indigoSoft} opacity="0.9" />
      </marker>
    </defs>
  );
};

export const ElGrid = ({ width, height, left = 48, top = 56, cols = 12, rows = 8, c }) => (
  <g opacity="0.38">
    {Array.from({ length: cols + 1 }).map((_, i) => {
      const x = left + (i * (width - left * 2)) / cols;
      return <line key={`v-${i}`} x1={x} y1={top} x2={x} y2={height - 40} stroke={c.grid} strokeWidth="0.5" />;
    })}
    {Array.from({ length: rows + 1 }).map((_, i) => {
      const y = top + (i * (height - top - 48)) / rows;
      return <line key={`h-${i}`} x1={left} y1={y} x2={width - left} y2={y} stroke={c.grid} strokeWidth="0.5" />;
    })}
  </g>
);

export const ElSectionLabel = ({ x, y, children, c, anchor = 'middle' }) => (
  <text x={x} y={y} textAnchor={anchor} fill={c.muted} fontSize="10" fontWeight="600" letterSpacing="4">
    {children}
  </text>
);

export const ElPanel = ({ x, y, w, h, prefix, c, children, rx = 8, active = false, stroke, className = '' }) => (
  <g filter={`url(#${prefix}-shadow)`} className={className}>
    <rect
      x={x}
      y={y}
      width={w}
      height={h}
      rx={rx}
      fill={`url(#${prefix}-panel)`}
      stroke={stroke || (active ? c.indigo : c.panelStroke)}
      strokeWidth={active ? 1.5 : 1}
    />
    {children}
  </g>
);

export const ElConnector = ({ x1, y1, x2, y2, c, prefix }) => (
  <line
    x1={x1}
    y1={y1}
    x2={x2}
    y2={y2}
    stroke={c.panelStroke}
    strokeWidth="1"
    markerEnd={`url(#${prefix}-arrow)`}
    opacity="0.85"
  />
);

export const ElBus = ({ x1, y1, x2, y2, prefix, className = '' }) => (
  <line
    x1={x1}
    y1={y1}
    x2={x2}
    y2={y2}
    stroke={`url(#${prefix}-bus)`}
    strokeWidth="2"
    strokeLinecap="round"
    className={className}
  />
);
